import { MissionLight } from '@wwf/sdk';
import { Avatar, Stack, Typography } from '@mui/material';
import { Link, useRecordContext } from 'react-admin';
import { getLinkToMission } from '../getLinkToMission';
import { MissionDateChip } from '../chips/MissionDateChip';
import { useResource } from '@app/misc/useResource';
import { SessionCount } from '../chips/SessionCount';

export const MissionLightCard = (props: {
    record?: MissionLight;
    noLink?: boolean;
    noDate?: boolean;
    twoLines?: boolean;
}) => {
    const record = useRecordContext<MissionLight>(props);
    const { data: iconSrc } = useResource(record?.type?.icon?.id);

    if (!record) return null;

    const icon = iconSrc ? (
        <Avatar
            src={iconSrc}
            variant="rounded"
            sx={{ width: 20, height: 20, flexShrink: 0 }}
        />
    ) : undefined;

    const text = (
        <Stack sx={props.twoLines ? { minWidth: 0, flex: 1 } : undefined}>
            <Typography variant="body2" noWrap={!props.twoLines}>
                {record.name}
            </Typography>
            <Typography variant="caption" noWrap={!props.twoLines}>
                {record.antenna && ' at '}
                {record.antenna?.name}
            </Typography>
        </Stack>
    );

    const meta = !props.noDate ? (
        <Stack direction="row" alignItems="center" gap={0.5}>
            <MissionDateChip date={record.startDate} />
            <SessionCount count={record.nbSessions ?? 0} />
        </Stack>
    ) : null;

    const content = props.twoLines ? (
        <Stack gap={0.5} sx={{ width: '100%' }}>
            <Stack direction="row" alignItems="flex-start" gap={0.5}>
                {icon}
                {text}
            </Stack>
            {meta}
        </Stack>
    ) : (
        <Stack direction="row" alignItems="center" gap={0.5}>
            {icon}
            {text}
            {meta}
        </Stack>
    );

    return props.noLink ? (
        content
    ) : (
        <Link to={getLinkToMission(record?.id)}>{content}</Link>
    );
};
